var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "left-toolbar mb10" },
      [
        _c(
          "button",
          {
            staticClass: "swb-btn-small swb-btn",
            on: { click: _vm.exportPdf }
          },
          [_vm._v("导出为pdf")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn-small swb-btn",
            on: { click: _vm.exportExcel }
          },
          [_vm._v("导出为EXCEL")]
        ),
        _vm._v(" "),
        _vm.goodsOrderMapInfo.origFileGenerated == false
          ? [
              _c(
                "button",
                {
                  staticClass: "swb-btn-small swb-btn",
                  staticStyle: { float: "right" },
                  on: { click: _vm.genEsignFile }
                },
                [_vm._v("生成待签署PDF文件")]
              )
            ]
          : [
              _c(
                "button",
                {
                  staticClass: "swb-btn-small swb-btn",
                  staticStyle: { float: "right" },
                  on: {
                    click: function($event) {
                      _vm.downloadEsignFile(_vm.goodsOrderMapInfo.origFileUuid)
                    }
                  }
                },
                [_vm._v("下载待签署PDF文件")]
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "goodOrderInfoPdf" } }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [
          _vm.goodsOrderMapInfo.buyerBizUnitName !=
          _vm.goodsOrderMapInfo.buyerComName
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.goodsOrderMapInfo.buyerBizUnitName) +
                    "-\n            " +
                    _vm._s(_vm.goodsOrderMapInfo.buyerComName)
                ),
                _vm.goodsOrderMapInfo.contractId != null
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.contractTitle))
                    ])
                  : _vm._e(),
                _vm._v("购销订单/验收单\n        ")
              ])
            : _c("span", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.goodsOrderMapInfo.buyerBizUnitName)
                ),
                _vm.goodsOrderMapInfo.contractId != null
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.contractTitle))
                    ])
                  : _vm._e(),
                _vm._v("购销订单/验收单\n        ")
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "10px",
            "word-break": "break-strict"
          }
        },
        [
          _c(
            "tbody",
            { staticClass: "body" },
            [
              _c("tr", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.buyerRealComName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.buyerComName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "2" }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.goodsOrderMapInfo.orderNo))])]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.sellerName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.sellerComContactName))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "2" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.submitTime))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _vm.goodsOrderMapInfo.sellerInnerCode != null
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.goodsOrderMapInfo.sellerInnerCode))
                        ])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.goodsOrderMapInfo.sellerNo))
                        ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.sellerComContactTel))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(8),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "2" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.desireArriveDate))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.goodsOrderMapInfo.goodsOrderItemList != null &&
              _vm.goodsOrderMapInfo.goodsOrderItemList.length > 0
                ? _c("tr", { staticClass: "row" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _vm._m(12),
                    _vm._v(" "),
                    _vm._m(13),
                    _vm._v(" "),
                    _vm._m(14),
                    _vm._v(" "),
                    _vm._m(15),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #1a1a1a",
                          "vertical-align": "middle",
                          padding: "10px 4px",
                          "text-align": "center",
                          color: "#1a1a1a",
                          "font-size": "10px"
                        },
                        attrs: { rowspan: "2" }
                      },
                      [
                        _c("span", [
                          _vm._v("含税单价"),
                          _c("br"),
                          _vm._v(" "),
                          _vm.goodsOrderMapInfo.taxRate != null
                            ? _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.goodsOrderMapInfo.taxRate) +
                                    "%)"
                                )
                              ])
                            : _vm.goodsOrderMapInfo.taxRate == null &&
                              _vm.goodsOrderMapInfo.goodsOrderItemList !=
                                null &&
                              _vm.goodsOrderMapInfo.goodsOrderItemList.length >
                                0
                            ? _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.goodsOrderMapInfo
                                        .goodsOrderItemList[0].taxRate
                                    ) +
                                    "%)"
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(16),
                    _vm._v(" "),
                    _vm._m(17),
                    _vm._v(" "),
                    _vm._m(18)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.goodsOrderMapInfo.goodsOrderItemList != null &&
              _vm.goodsOrderMapInfo.goodsOrderItemList.length > 0
                ? _c("tr", { staticClass: "row" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _vm._m(20)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.goodsOrderMapInfo.goodsOrderItemList, function(
                itemInfo,
                index
              ) {
                return _c("tr", { staticClass: "row" }, [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      _c("span", { attrs: { wbr: "true" } }, [
                        _vm._v(_vm._s(index + 1))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      _c("span", { attrs: { wbr: "true" } }, [
                        _vm._v(_vm._s(itemInfo.assetDefCode || ""))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      _c("span", { attrs: { wbr: "true" } }, [
                        _vm._v(_vm._s(itemInfo.title))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      _c("span", { attrs: { wbr: "true" } }, [
                        _vm._v(_vm._s(itemInfo.fixedSpec))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(itemInfo.unit))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      _c("span", { attrs: { wbr: "true" } }, [
                        _vm._v(_vm._s(itemInfo.quantity || 0))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      itemInfo.ntxPrice != null
                        ? _c("span", { attrs: { wbr: "true" } }, [
                            _vm._v(_vm._s(itemInfo.ntxPrice.toFixed(2)))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      itemInfo.price != null
                        ? _c("span", { attrs: { wbr: "true" } }, [
                            _vm._v(_vm._s(itemInfo.price.toFixed(2)))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "center",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      itemInfo.amount != null
                        ? _c("span", { attrs: { wbr: "true" } }, [
                            _vm._v(_vm._s(itemInfo.amount.toFixed(2)))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px",
                        "text-align": "left",
                        color: "#1a1a1a",
                        "font-size": "10px"
                      }
                    },
                    [
                      _c("span", { attrs: { wbr: "true" } }, [
                        _vm._v(_vm._s(itemInfo.desc || ""))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(21, true),
                  _vm._v(" "),
                  _vm._m(22, true)
                ])
              }),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(23),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "right",
                      color: "#1a1a1a",
                      "background-color": "#efefef",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "7" }
                  },
                  [
                    _vm.goodsOrderMapInfo.totalAmont != null
                      ? _c("span", { attrs: { wbr: "true" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.goodsOrderMapInfo.totalAmont.toFixed(2)
                            ) + "元"
                          )
                        ])
                      : _c("span", [_vm._v("0.00元")])
                  ]
                ),
                _vm._v(" "),
                _vm._m(24),
                _vm._v(" "),
                _vm._m(25),
                _vm._v(" "),
                _vm._m(26)
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(27),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "right",
                      color: "#1a1a1a",
                      "background-color": "#efefef",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "7" }
                  },
                  [
                    _vm.goodsOrderMapInfo.totalAmontChsMoneyStr != null
                      ? _c("span", { attrs: { wbr: "true" } }, [
                          _vm._v(
                            _vm._s(_vm.goodsOrderMapInfo.totalAmontChsMoneyStr)
                          )
                        ])
                      : _c("span", [_vm._v("零元整")])
                  ]
                ),
                _vm._v(" "),
                _vm._m(28)
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(29),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "7" }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.buyerComAddress))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(30),
                _vm._v(" "),
                _vm._m(31)
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(32),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.goodsOrderMapInfo.buyerComContactName) +
                          " " +
                          _vm._s(_vm.goodsOrderMapInfo.buyerComContactTel)
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(33),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "3" }
                  },
                  [
                    _c("span", { attrs: { wbr: "true" } }, [
                      _vm._v(_vm._s(_vm.goodsOrderMapInfo.receiveDate || ""))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._m(34),
                _vm._v(" "),
                _vm._m(35)
              ]),
              _vm._v(" "),
              _c("tr", { staticClass: "row" }, [
                _vm._m(36),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      border: "1px solid #1a1a1a",
                      "vertical-align": "middle",
                      padding: "10px 4px",
                      "text-align": "left",
                      color: "#1a1a1a",
                      "font-size": "10px"
                    },
                    attrs: { colspan: "10" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "货到验收合格后三个月支付" +
                          _vm._s(_vm.goodsOrderMapInfo.amountPayPct || 0) +
                          "%；"
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(37),
              _vm._v(" "),
              _vm._m(38),
              _vm._v(" "),
              _vm._m(39),
              _vm._v(" "),
              _vm._m(40),
              _vm._v(" "),
              _vm._m(41),
              _vm._v(" "),
              _vm._m(42),
              _vm._v(" "),
              _vm._m(43),
              _vm._v(" "),
              _vm._m(44),
              _vm._v(" "),
              _vm._m(45),
              _vm._v(" "),
              _vm._m(46),
              _vm._v(" "),
              _vm._m(47)
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("甲方公司")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("门店名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("订货单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("乙方公司")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("乙方联系人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("订购日期")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("供商编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("乙方联系电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("到货日期")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("序号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("规格编码")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("产品名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("规格")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("单位")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("未税单价")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("含税总价")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span", [_vm._v("备注")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("验收明细")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("验收数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("验收金额")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", { attrs: { wbr: "true" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", { attrs: { wbr: "true" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "background-color": "#efefef",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("合计（小写）")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "background-color": "#efefef",
          "font-size": "10px"
        }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "background-color": "#efefef",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "background-color": "#efefef",
          "font-size": "10px"
        },
        attrs: { rowspan: "2" }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "background-color": "#efefef",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("产品总价（大写）")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "background-color": "#efefef",
          "font-size": "10px"
        }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("设备送货地址")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("接货联系人及电话")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("实际到"), _c("br"), _vm._v("货日期")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        }
      },
      [_c("span", [_vm._v("接货情况")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "left",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          border: "1px solid #1a1a1a",
          "vertical-align": "middle",
          padding: "10px 4px",
          "text-align": "center",
          color: "#1a1a1a",
          "font-size": "10px"
        },
        attrs: { colspan: "2" }
      },
      [_c("span", [_vm._v("付款方式")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("验收方式")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "10" }
        },
        [
          _c("span", [
            _vm._v(
              "根据年采合同验收标准，现场由厂家送货人员、店铺资产管理员或后勤主管及店总三方签字进行验收（以实际验收数量及金额进行费用结算）,经甲方盖章及资产采购人员签字后方为有效。"
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("保险/运输/其他")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "10" }
        },
        [
          _c("span", [
            _vm._v(
              "乙方负责设备的全部保险，乙方负责包装及全部运费，其它各项相关条款均执行年采合同条款。"
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row", attrs: { valign: "top" } }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px",
            height: "150px"
          },
          attrs: { colspan: "6" }
        },
        [
          _c(
            "span",
            { staticStyle: { float: "left", "line-height": "120px" } },
            [_vm._v("甲方盖章：")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px",
            height: "150px"
          },
          attrs: { colspan: "6" }
        },
        [
          _c(
            "span",
            { staticStyle: { float: "left", "line-height": "120px" } },
            [_vm._v("乙方盖章：")]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "6" }
        },
        [
          _c("div", [_vm._v("甲方法人/委托人代理签字：")]),
          _vm._v(" "),
          _c("div", [_vm._v("甲方签署日期：")])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "6" }
        },
        [
          _c("div", [_vm._v("乙方法人/委托人代理签字：")]),
          _vm._v(" "),
          _c("div", [_vm._v("乙方签署日期：")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { rowspan: "4" }
        },
        [_c("span", [_vm._v("使用部门"), _c("br"), _vm._v("验收意见")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("*设备状况是否正常")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [
          _c("span", [_vm._v("是：□")]),
          _vm._v(" "),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v("否：□")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("*施工是否安全文明")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [
          _c("span", [_vm._v("是：□")]),
          _vm._v(" "),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v("否：□")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("*附属配件是否齐全")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [
          _c("span", [_vm._v("是：□")]),
          _vm._v(" "),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v("否：□")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("*垃圾清理是否及时")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [
          _c("span", [_vm._v("是：□")]),
          _vm._v(" "),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v("否：□")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("*外观形状是否符合")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [
          _c("span", [_vm._v("是：□")]),
          _vm._v(" "),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v("否：□")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("*来货设备是否闲置")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [
          _c("span", [_vm._v("是：□")]),
          _vm._v(" "),
          _c("span", { staticStyle: { "margin-left": "5px" } }, [
            _vm._v("否：□")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("设备质量问题")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "9" }
        },
        [_c("span")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { rowspan: "2" }
        },
        [_c("span", [_vm._v("确认签字")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("*资产管理员/维修课长（日期）")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("*供应商（日期）")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "2" }
        },
        [_c("span", [_vm._v("*店总/负责人（日期）")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("*资产采购")])]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "left",
            color: "#1a1a1a",
            "font-size": "10px"
          },
          attrs: { colspan: "12" }
        },
        [
          _c("span", [
            _vm._v("注：带*为必填项"),
            _c("br"),
            _vm._v("*1.验收必须经甲方资产采购人员签字确认后方为有效验收单。"),
            _c("br"),
            _vm._v(
              "2.本订单签署单价为未税金额、乙方需提供税务机关认可的13%增值税专用发票，如国家统一调整税率，即按调整后税率执行，未税金额不变。"
            ),
            _c("br"),
            _vm._v(
              "3.本订单一式肆份，双方各执贰份，应明确写明验收数量、验收金额、验收日期；未约定或约定不明的，按双方签订的年采合同执行。"
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f7fb02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f7fb02","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsOrderInfoForPdf.vue
// module id = 2986
// module chunks = 0